import { PlatformSpecificationEditor } from './components/forms/platform-specification-editor/platform-specification-editor.component';

import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from '@synthroneApp/app.component';
import { AppLayoutComponent } from '@synthroneApp/components/app-layout/app-layout.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';

import { FormsModule } from '@angular/forms';
import { NgModule } from '@angular/core';
import { MomentModule } from 'angular2-moment';
import { routing} from '@synthroneApp/app.routing';
import { SynthroneDataService } from '@synthroneApp/services/synthrone-data/synthrone-data.service';
import { SYNTHRONE_CONFIG, APP_CONFIG} from './app.config';
import { SynthroneModule } from '@angular/synthrone-design/synthrone.module';
import { DashboardViewComponent } from '@synthroneApp/components/views/dashboard/dashboard.component';
import { UsersViewComponent } from '@synthroneApp/components/views/users/users.component';
import { NotificationsViewComponent } from '@synthroneApp/components/views/notifications/notifications.component';
import { MaintenanceViewComponent } from '@synthroneApp/components/views/maintenance/maintenance.component';
import { LoginViewComponent } from '@synthroneApp/components/views/login/login.component';

import { MatNativeDateModule } from '@angular/material';
import { DatePickerModule } from '@synthroneApp/components/views/maintenance/datepicker.module';
import { AuthenticateGuard } from '@synthroneApp/guards/authenticate/authenticate.guard';

import { OrganizationsViewComponent } from '@synthroneApp/components/views/organizations-view/organizations-view.component';
import { OrganizationAddViewComponent } from '@synthroneApp/components/views/organization-add-view/organization-add-view.component';
import { OrganizationsComponentsViewComponent } from '@synthroneApp/components/views/organizations-components-view/organizations-components-view.component';
import { OrganizationParametersViewComponent } from '@synthroneApp/components/views/organization-parameters-view/organization-parameters-view.component';
import { LanguagesViewComponent } from '@synthroneApp/components/views/languages-view/languages-view.component';
import { SectionsViewComponent } from '@synthroneApp/components/views/sections-view/sections-view.component';
import { SectionAddViewComponent } from '@synthroneApp/components/views/section-add-view/section-add-view.component';
import { ComponentsViewComponent } from '@synthroneApp/components/views/components-view/components-view.component';
import { ComponentAddViewComponent } from '@synthroneApp/components/views/component-add-view/component-add-view.component';
import { ComponentVariantsViewComponent } from '@synthroneApp/components/views/component-variants-view/component-variants-view.component';
import { ComponentVariantFormComponent } from '@synthroneApp/components/forms/component-variant-form/component-variant-form.component';
import { PlatformsViewComponent } from '@synthroneApp/components/views/platforms-view/platforms-view.component';
import { PlatformAddViewComponent } from '@synthroneApp/components/views/platform-add-view/platform-add-view.component';
import { PlatformTemplateViewComponent } from '@synthroneApp/components/views/platform-template-view/platform-template-view.component';
import { AttributesViewComponent } from '@synthroneApp/components/views/attributes-view/attributes-view.component';
import { AttributeAddViewComponent } from '@synthroneApp/components/views/attribute-add-view/attribute-add-view.component';
import { CountriesViewComponent } from '@synthroneApp/components/views/countries-view/countries-view.component';
import { AttributesGroupsViewComponent } from '@synthroneApp/components/views/attributes-groups-view/attributes-groups-view.component';
import { AttributesGroupsAddViewComponent } from '@synthroneApp/components/views/attributes-groups-add-view/attributes-groups-add-view.component';
import { PipelinesViewComponent } from '@synthroneApp/components/views/pipelines-view/pipelines-view.component';
import { PipelineAddViewComponent } from '@synthroneApp/components/views/pipeline-add-view/pipeline-add-view.component';
import { OrganizationsFeaturesViewComponent } from '@synthroneApp/components/views/organizations-features-view/organizations-features-view.component';

import { ConfigService } from '@angular/synthrone-design/services';
import { AppConfigService } from './services/app-config/app-config.service';
import { ScenariosMonitoringViewComponent } from './components/views/scenarios-monitoring-view/scenarios-monitoring-view.component';
import { ClockChartComponent } from './components/chunks/clock-chart/clock-chart.component';

import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { OrganizationFontsViewComponent } from './components/views/organization-fonts-view/organization-fonts-view.component';
import { AddUpdateFontFormComponent } from './components/forms/add-update-font-form/add-update-font-form.component';
import { OrganizationFontVariantsViewComponent } from './components/views/organization-font-variants-view/organization-font-variants-view.component';
import { AddUpdateFontVariantComponent } from './components/forms/add-update-font-variant/add-update-font-variant.component';
import { AddUpdateFeatureVariantComponent } from './components/forms/add-update-feature-variant/add-update-feature-variant.component';
import {
  CustomProductSectionsEditorComponent
} from '@synthroneApp/components/forms/custom-product-sections-editor/custom-product-sections-editor.component';
import { MsSystemApiModule } from 'ms-system-angular-sdk';
import { SortAlphabetically } from './pipes/sort-alphabetically/sort-alphabetically.pipe';

import { MsLanguageCountryApiModule } from 'ms-language-country-angular-sdk';
import { NotificationBarEditorComponent } from './components/forms/notification-bar-editor/notification-bar-editor.component';
import { NotificationBarFormComponent } from './components/forms/notification-bar-editor/notification-bar-form/notification-bar-form.component';
import { IsValidUrlDirective } from './directives/is-valid-url.directive';

@NgModule({
    declarations: [
        AppComponent,
        AppLayoutComponent,
        DashboardViewComponent,
        UsersViewComponent,
        NotificationsViewComponent,
        MaintenanceViewComponent,
        LoginViewComponent,
        OrganizationsViewComponent,
        OrganizationAddViewComponent,
        OrganizationsComponentsViewComponent,
        OrganizationParametersViewComponent,
        LanguagesViewComponent,
        SectionsViewComponent,
        SectionAddViewComponent,
        ComponentsViewComponent,
        ComponentAddViewComponent,
        ComponentVariantsViewComponent,
        ComponentVariantFormComponent,
        PlatformsViewComponent,
        PlatformAddViewComponent,
        PlatformTemplateViewComponent,
        AttributesViewComponent,
        AttributeAddViewComponent,
        AttributesGroupsViewComponent,
        AttributesGroupsAddViewComponent,
        CountriesViewComponent,
        PlatformSpecificationEditor,
        PipelinesViewComponent,
        PipelineAddViewComponent,
        ScenariosMonitoringViewComponent,
        ClockChartComponent,
        OrganizationFontsViewComponent,
        AddUpdateFontFormComponent,
        OrganizationFontVariantsViewComponent,
        AddUpdateFontVariantComponent,
        AddUpdateFeatureVariantComponent,
        OrganizationsFeaturesViewComponent,
        CustomProductSectionsEditorComponent,
        SortAlphabetically,
        NotificationBarEditorComponent,
        NotificationBarFormComponent,
        IsValidUrlDirective
    ],
    exports: [
        AppLayoutComponent
    ],
    entryComponents: [
        ComponentVariantFormComponent,
        PlatformSpecificationEditor,
        AddUpdateFontFormComponent,
        AddUpdateFeatureVariantComponent,
        OrganizationFontVariantsViewComponent,
        AddUpdateFontVariantComponent,
        CustomProductSectionsEditorComponent,
        NotificationBarEditorComponent
    ],
    imports: [
        BrowserAnimationsModule,
        BrowserModule,
        CommonModule,
        FormsModule,
        HttpClientModule,
        MomentModule,
        routing,
        SynthroneModule,
        MatNativeDateModule,
        DatePickerModule,
        NgxMatSelectSearchModule,
        MsSystemApiModule,
        MsLanguageCountryApiModule
    ],
    providers: [
        SynthroneDataService,
        AuthenticateGuard,
        AppConfigService,
        { provide: ConfigService, useExisting: AppConfigService },
        { provide: APP_CONFIG, useValue: SYNTHRONE_CONFIG }
    ],
    bootstrap: [
        AppComponent
    ]
})
export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts